export const CLOUD_UNCONFIGURED_STATUS = "CLOUD_UNCONFIGURED";

export const formatRequestStatus = (status?: string) => (status || "").replace(/_/g, " ");

const toTitleCase = (value: string) =>
  value
    .replace(/_/g, " ")
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .trim()
    .split(/\s+/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");

const toSingular = (value: string) => (/[^s]s$/.test(value) ? value.slice(0, -1) : value);

export const getAzureScopeDetails = (scope?: string | null, scopeType?: string | null) => {
  const segments = (scope || "").split("/").filter(Boolean);
  const lowerSegments = segments.map((segment) => segment.toLowerCase());
  const groupIndex = lowerSegments.indexOf("resourcegroups");
  const providerIndex = lowerSegments.lastIndexOf("providers");
  const resourceGroup = groupIndex >= 0 ? segments[groupIndex + 1] : undefined;
  const providerType =
    providerIndex >= 0 && segments.length >= providerIndex + 4 ? segments[segments.length - 2] : undefined;

  let resourceType = "";
  if (scopeType) resourceType = toTitleCase(scopeType);
  else if (providerType) resourceType = toSingular(toTitleCase(providerType));
  else if (resourceGroup) resourceType = "Resource Group";
  else if (segments.length) resourceType = "Subscription";

  return { resourceGroup, resourceType };
};

export const getStatusColor = (status: string) => {
  switch (status) {
    case "PENDING":
      return "bg-amber-600 text-white border-amber-600";
    case "APPROVED":
      return "bg-green-600 text-white border-green-600";
    case "DECLINE":
      return "bg-red-500 text-white border-red-500";
    case "REVOKED":
      return "bg-purple-500 text-white border-purple-500";
    case "EXPIRED":
      return "bg-gray-500 text-white border-gray-500";
    case "CLOUD_UNCONFIGURED":
      return "bg-orange-600 text-white border-orange-600";
    default:
      return "bg-slate-500 text-white border-slate-500";
  }
};
